// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"M4-z"};